//Action creator with callback function
export function setPersonalizationDetails(orderPromotionDetail = null) { //TODO null added temporary, need to remove
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: 'SET_PERSONALIZATION_DATA',
                payload: orderPromotionDetail
            });
            resolve(true)
        });
    }
};

export const resetPersonalizationDetails = () => ({
    type: 'RESET_PERSONALIZATION_DATA'
});